module.exports = __webpack_public_path__ + "img/rainbow.b39c4f59.png";